import { render, staticRenderFns } from "./QRCodeVNPayModal.vue?vue&type=template&id=30358129&scoped=true"
import script from "./QRCodeVNPayModal.vue?vue&type=script&lang=js"
export * from "./QRCodeVNPayModal.vue?vue&type=script&lang=js"
import style0 from "./QRCodeVNPayModal.vue?vue&type=style&index=0&id=30358129&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30358129",
  null
  
)

export default component.exports